/* Loom Loom main menu behaviour (2b desktop / 2a mobile). No dependencies. */
(function () {
  function init() {
    /* ---------- Desktop mega menu + Club ---------- */
    var triggers = [].slice.call(document.querySelectorAll('[data-llm-trigger]'));
    var scrim = document.querySelector('[data-llm-scrim]');
    var nav = document.querySelector('[data-llm-nav]');
    if (triggers.length && scrim) {
      var panels = [].slice.call(document.querySelectorAll('[data-llm-panel]'));
      document.body.appendChild(scrim);
      panels.forEach(function (p) { document.body.appendChild(p); });
      var header = triggers[0].closest('header, .header, sticky-header, .section-header, .shopify-section') || triggers[0].parentElement;
      var current = null, openT, closeT;
      var setTop = function () { document.documentElement.style.setProperty('--llm-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px'); };
      var panelFor = function (t) { return document.getElementById(t.getAttribute('data-llm-trigger')); };
      var open = function (t) {
        clearTimeout(closeT); clearTimeout(openT); setTop();
        document.querySelectorAll('header details[open]').forEach(function (d) { d.removeAttribute('open'); });
        triggers.forEach(function (x) { var on = x === t; x.setAttribute('aria-expanded', on ? 'true' : 'false'); panelFor(x).hidden = !on; });
        scrim.hidden = false; current = t;
        if (nav) nav.classList.toggle('is-open', nav.contains(t));
      };
      var close = function () {
        clearTimeout(openT);
        triggers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); panelFor(x).hidden = true; });
        scrim.hidden = true; current = null; if (nav) nav.classList.remove('is-open');
      };
      var soon = function () { clearTimeout(openT); clearTimeout(closeT); closeT = setTimeout(close, 200); };

      triggers.forEach(function (t) {
        var isBtn = t.tagName === 'BUTTON';
        t.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); if (current) open(t); else openT = setTimeout(function () { open(t); }, 150); });
        t.addEventListener('mouseleave', soon);
        if (isBtn) t.addEventListener('click', function () { current === t ? close() : open(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || (!isBtn && e.key === ' ')) { e.preventDefault(); open(t); var f = panelFor(t).querySelector('a, button'); if (f) f.focus(); }
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var i = triggers.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
            if (triggers[i]) { e.preventDefault(); triggers[i].focus(); if (current) open(triggers[i]); }
          }
        });
        var p = panelFor(t);
        p.addEventListener('mouseenter', function () { clearTimeout(closeT); });
        p.addEventListener('mouseleave', soon);
      });
      scrim.addEventListener('mouseenter', close);
      scrim.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) { var t = current; close(); t.focus(); } });
      window.addEventListener('scroll', function () { if (current) setTop(); }, { passive: true });
      window.addEventListener('resize', function () { if (current) setTop(); });
    }

    /* ---------- Mobile sub-panels ---------- */
    var mobile = document.querySelector('[data-llm-mobile]');
    if (mobile) {
      var mtop = function () { var r = mobile.getBoundingClientRect(); document.documentElement.style.setProperty('--llm-mtop', Math.max(0, r.top) + 'px'); };
      mobile.querySelectorAll('[data-llm-open]').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('data-llm-open'));
        var back = panel.querySelector('[data-llm-back]');
        btn.addEventListener('click', function () { mtop(); panel.hidden = false; panel.scrollTop = 0; btn.setAttribute('aria-expanded', 'true'); back.focus(); });
        var hide = function () { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); };
        back.addEventListener('click', hide);
        panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      });
      // When the theme closes its drawer, reset any open sub-panel.
      var reset = function () { mobile.querySelectorAll('[data-llm-mpanel]').forEach(function (p) { p.hidden = true; }); };
      new MutationObserver(function () { if (!mobile.offsetParent) reset(); }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'class', 'aria-expanded'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();